import AxiosClient from "../../../services/axios.services";

class PlanSeguimientoServices {
  getPlanSeguimiento = (params) =>
    AxiosClient.get(
      "/api/app/llenado_formulario_carrera/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  
  savePlanSeguimiento = (data) =>
    AxiosClient.post(
      "/api/app/carrera_plan_plan_accion/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editPlanAccion = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_plan_accion/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    editPlan = (id, data) =>
      AxiosClient.put(
        `/api/app/carrera_plan/${id}/`,
        data,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
}

export default new PlanSeguimientoServices();
